import * as angular from 'angular';

import { IValueViewModel, Group, ComponentDefinition, Dashboard, Dictionary, ObjectUser, ApprovalSettings } from '../../../models';
import { IIdentifierCascadeDeleteService, IStoreService, ITranslatedLoggerService } from '../../../services';
import { Store, StoreElement } from '../../../stateManagement';

class IdentifierDeleteModalController implements angular.IComponentController {
    isLoading: boolean;
    message: string;

    deletable: ObjectUser[];
    undeletable: ObjectUser[];

    readonly item: IValueViewModel;
    readonly group: Group;
    readonly onDelete: () => void;
    readonly extraStyles = { 'position': 'relative', 'transform': 'unset', 'top': '35%', 'left': 'unset' };

    private _dashboards: Dictionary<Dashboard>;
    private _groups: Dictionary<Group>;
    private _viewModels: Dictionary<IValueViewModel>;
    private _approvalSettings: Dictionary<ApprovalSettings>;

    static $inject = [
        '$translate',
        'storeService',
        'identifierCascadeDeleteService',
        'translatedLoggerService'
    ];

    constructor(
        private _$translate: angular.translate.ITranslateService,
        private _storeService: IStoreService,
        private _identifierCascadeDeleteService: IIdentifierCascadeDeleteService,
        private _logger: ITranslatedLoggerService
    ) {

    }

    $onInit() {
        this._storeService.register(
            store => this.refreshStore(store),
            [StoreElement.Dashboards, StoreElement.ValueViewModels, StoreElement.ApprovalSettings]
        );
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (onChangesObj['item']?.currentValue) {
            this.deletable = this.item.users?.filter(d => d.isDeletable);
            this.undeletable = this.item.users?.filter(d => !d.isDeletable);
        }
    }

    deleteItem(item: IValueViewModel) {
        this.isLoading = true;
        const status = msg => this.message = this._$translate.instant(msg);

        this._identifierCascadeDeleteService
            .deleteIdentifier(item, this._dashboards, this._viewModels, this._groups, this._approvalSettings, status)
            .then(() => {
                this.closeModal();
                if (this.onDelete) {
                    this.onDelete();
                }
            })
            .catch(reason => this._logger.logError(reason))
            .finally(() => this.isLoading = false);
    }

    preventClick($event: angular.IAngularEvent) {
        // this prevent click to buble to state where it would unselect identifier thus changing the modal back
        $event.stopPropagation();
    }

    closeModal() {
        $('#deleteModal').modal('hide');
    }
    
    hasUndeleteable() {
        return !!this.undeletable?.length;
    }

    private refreshStore(store: Store) {
        this._dashboards = store.dashboards.dictionary;
        this._groups = store.groups.dictionary;
        this._viewModels = store.valueViewModels.dictionary;
        this._approvalSettings = store.approvalSettings.dictionary;
    }
}

export const wtIdentifierDeleteModal: ComponentDefinition = {
    componentId: 'wtIdentifierDeleteModal',
    controller: IdentifierDeleteModalController,
    template: require('./identifierDeleteModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '<',
        group: '<',
        onDelete: '&?'
    }
};